export default function Field({ label, required, children, hint }) {
  return (
    <label className="field">
      <span className="field-label">
        {label}
        {required ? <span className="req"> *</span> : null}
      </span>
      {children}
      {hint ? <span className="field-hint">{hint}</span> : null}
    </label>
  );
}
